import { Trigger as RadixTrigger, Root } from "@radix-ui/react-dropdown-menu";
import React, { ComponentProps, FC, ReactNode } from "react";
import { Portal } from "./Portal";

export const EffortEstimatedPopup: FC<{
  children: ReactNode;
  portalProps?: ComponentProps<typeof Portal>;
  menuVisibility?: boolean;
  onOpenChange?: (open: boolean) => void;
  disabledTrigger?: boolean;
}> = ({
  children,
  portalProps,
  menuVisibility,
  onOpenChange,
  disabledTrigger,
}) => {
  return (
    <Root open={menuVisibility} onOpenChange={onOpenChange}>
      <RadixTrigger
        className="outline-none w-full min-w-0 overflow-hidden"
        disabled={disabledTrigger}
      >
        {children}
      </RadixTrigger>
      <Portal {...portalProps} />
    </Root>
  );
};
